<div>
    <app-header-mysamples (onSearch)="onSearch($event)"></app-header-mysamples>
    <app-tabs [tabs]="tabs" [activeTab]="activeTab" (tabChanged)="onTabChanged($event)"></app-tabs>

    <div class="content">
        <div class="grid grid-cols-1 md:grid-cols-12 gap-4">
            <div class="order-1 md:order-2 md:col-span-12 w-full lg:order-1 lg:col-span-9">
                <div *ngIf="samples.length === 0 && (searchTerm == null || searchTerm === '')"
                    class="flex flex-col items-center justify-center gap-6 py-12 px-6 w-full no-samples-container">
                    <div class="typography-title-m text-center">{{ 'order_samples.no_samples' | translate }}</div>
                    <app-button [primary]="true" size="large"
                        [skin]="AccountType.isCtop(userInfo.accountType) ? 'ctop' : 'we'"
                        [gtmLabel]="'new-order_button_order-samples'"
                        (onClick)="goToRequestSamples()">
                        <div class="typography-body-m-medium" style="text-align: center; word-wrap: break-word">
                            {{'order_samples.request_samples' | translate}}</div>
                    </app-button>
                </div>

                <div class="projects grid gap-6 w-full" *ngIf="samples && samples.length > 0">
                    <app-samples-card *ngFor="let sample of samples" [sample]="sample"></app-samples-card>
                    <div *ngIf="hasNextPage === true">
                        <app-button [block]="true" (onClick)="nextPage()" [size]="'large'"
                            [skin]="AccountType.isCtop(userInfo.accountType) ? 'ctop' : 'we'">
                            {{ 'global.view_more' | translate }}
                        </app-button>
                    </div>
                </div>

            </div>

            <div class="order-2 md:order-1 md:col-span-12 lg:order-2 lg:col-span-3 ">
                <div class="w-full"
                    style="padding: 24px; background: #BDE2EC; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 16px; display: inline-flex">
                    <div
                        style="align-self: stretch; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 8px; display: flex">
                        <svg xmlns="http://www.w3.org/2000/svg" width="1.5rem" height="1.5rem" viewBox="0 0 24 24"
                            fill="none" style="vertical-align: middle;">
                            <path
                                class="{{ AccountType.isCtop(userInfo.accountType)? 'primaryCtopDefault' : 'primaryDefault' }}"
                                d="M11.5 16.5H12.5V11H11.5V16.5ZM12 9.575C12.1667 9.575 12.3127 9.51667 12.438 9.4C12.5627 9.28333 12.625 9.13333 12.625 8.95C12.625 8.78333 12.5627 8.64167 12.438 8.525C12.3127 8.40833 12.1667 8.35 12 8.35C11.8333 8.35 11.6873 8.40833 11.562 8.525C11.4373 8.64167 11.375 8.78333 11.375 8.95C11.375 9.13333 11.4373 9.28333 11.562 9.4C11.6873 9.51667 11.8333 9.575 12 9.575ZM12 21C10.75 21 9.57933 20.7627 8.488 20.288C7.396 19.8127 6.446 19.1707 5.638 18.362C4.82933 17.554 4.18733 16.604 3.712 15.512C3.23733 14.4207 3 13.25 3 12C3 10.75 3.23733 9.579 3.712 8.487C4.18733 7.39567 4.82933 6.44567 5.638 5.637C6.446 4.829 7.396 4.18733 8.488 3.712C9.57933 3.23733 10.75 3 12 3C13.25 3 14.421 3.23733 15.513 3.712C16.6043 4.18733 17.5543 4.829 18.363 5.637C19.171 6.44567 19.8127 7.39567 20.288 8.487C20.7627 9.579 21 10.75 21 12C21 13.25 20.7627 14.4207 20.288 15.512C19.8127 16.604 19.171 17.554 18.363 18.362C17.5543 19.1707 16.6043 19.8127 15.513 20.288C14.421 20.7627 13.25 21 12 21ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z" />
                        </svg>

                        <div
                            style="align-self: stretch;flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 8px; display: flex">
                            <div class="typography-title-m"
                                style="align-self: stretch; color: #323232; font-size: 20px; font-family: Diagramm; font-weight: 500; line-height: 24px; word-wrap: break-word">
                                {{'order_samples.ask_for_samples' | translate}}</div>
                            <div class="typography-body-l-regular"
                                style="align-self: stretch; color: #323232; word-wrap: break-word">
                                {{'order_samples.new_samples_colors' | translate}}</div>
                        </div>
                    </div>
                    <div
                        style="align-self: stretch; flex-direction: column; justify-content: center; align-items: center; gap: 8px; display: flex;">

                        <ng-container *ngIf="userInfo">
                            <app-button [style]="{width:'100%'}" [block]="true" size="large"
                                [skin]="AccountType.isCtop(userInfo.accountType) ? 'ctop' : 'we'"
                                [gtmLabel]="'new-order_button_order-samples'"
                                (onClick)="goToRequestSamples()">
                                <div class="typography-body-m-medium" style="text-align: center; word-wrap: break-word">
                                    {{'order_samples.request_samples' | translate}}</div>
                            </app-button>
                        </ng-container>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>